import { render, staticRenderFns } from "./OwnerPasswordReset.vue?vue&type=template&id=b502f762&scoped=true"
import script from "./OwnerPasswordReset.vue?vue&type=script&lang=js"
export * from "./OwnerPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./OwnerPasswordReset.vue?vue&type=style&index=0&id=b502f762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b502f762",
  null
  
)

export default component.exports